import React, { useEffect, useState } from "react";
import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card, Switch, FormControlLabel } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { useParams } from "react-router-dom";
import { colors } from "components/Theme/WebTheme";
import { WEB_MAIN_COLOR, WEB_SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import { makeStyles } from "@mui/styles";
import GoBackButton from "components/GoBackButton";

const { formatNumberInput, handleVietnameseNumberInput } = api;

const useStyles = makeStyles((theme) => ({
  typography: {
    fontFamily: FONT_FAMILY,
  },
  textField: props => ({
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  selectField: props => ({
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
  }),
  rootRtl_3: props => ({
    "& label": {
      right: 17,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  rootRtl: props => ({
    "& label": {
      right: 20,
      left: "auto",
      paddingRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 15,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  rootRtl_1: props => ({
    "& label": {
      right: 0,
      left: "auto",
      paddingRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 30,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  rootRtl_2: props => ({
    "& label": {
      right: 17,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  rootRtl_4: props => ({
    "& label": {
      right: 17,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 15,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  rootRtl_5: props => ({
    "& label": {
      right: 17,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  }),
  selectField_rtl: props => ({
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
    },
    "& label": {
      right: 0,
      left: "auto",
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 35,
      fontFamily: FONT_FAMILY,
    },
  }),
  right: {
    textAlign: "right",
    right: 0,
    left: "auto",
    paddingRight: 40,
    fontFamily: FONT_FAMILY,
  },
}));

const EditCarType = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const cartypes = useSelector((state) => state.cartypes);
  const carlistdata = useSelector((state) => state.carlistdata);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loding, setLoding] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const { editCarType, updateUserCar, editCar, convertLanguage } = api;
  const [oldData, setOldData] = useState(null);
  const [data, setData] = useState(null);
  const classes = useStyles({settings});
  const { state } = useLocation()
  const auth = useSelector((state) => state.auth);

  // Display states for Vietnamese formatted amounts
  const [displayBaseFare, setDisplayBaseFare] = useState("");
  const [displayMinFare, setDisplayMinFare] = useState("");
  const [displayRatePerHour, setDisplayRatePerHour] = useState("");
  const [displayRatePerDistance, setDisplayRatePerDistance] = useState("");
  const [displayConvenienceFees, setDisplayConvenienceFees] = useState("");
  const [displayFleetAdminFee, setDisplayFleetAdminFee] = useState("");
  const MAIN_COLOR = WEB_MAIN_COLOR(settings?.appCat);
  const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);

  //timezone and time 
  const timezoneEnabled = Boolean(settings?.enable_timezone);
  const serviceTimezoneId = settings?.service_timezone_id || "America/Sao_Paulo";

  useEffect(() => {
    if (id) {
      if (cartypes && cartypes.cars) {
        const carData = cartypes.cars.filter(
          (item) => item.id === id.toString()
        )[0];
        if (!carData) {
          navigate("/404");
        }
        setData(carData);

        const tp = normalizeTimePricing(carData.time_pricing);

        setData({
          ...carData,
          // switch do modo: usar intervalos ou não
          use_time_pricing: tp.enabled ?? false,
          time_pricing: {
            enabled: tp.enabled ?? false,
            configured_timezone_id: tp.configured_timezone_id,
            rulesArr: tp.rulesArr
          }
        });

        setOldData(carData);

        // Initialize display values for Vietnamese formatting
        if (settings?.country === "Vietnam") {
          setDisplayBaseFare(formatNumberInput(carData.base_fare || 0, "vi-VN"));
          setDisplayMinFare(formatNumberInput(carData.min_fare || 0, "vi-VN"));
          setDisplayRatePerHour(formatNumberInput(carData.rate_per_hour || 0, "vi-VN"));
          setDisplayRatePerDistance(formatNumberInput(carData.rate_per_unit_distance || 0, "vi-VN"));
          setDisplayConvenienceFees(formatNumberInput(carData.convenience_fees || 0, "vi-VN"));
          setDisplayFleetAdminFee(formatNumberInput(carData.fleet_admin_fee || 0, "vi-VN"));
        } else {
          setDisplayBaseFare(carData.base_fare?.toString() || "0");
          setDisplayMinFare(carData.min_fare?.toString() || "0");
          setDisplayRatePerHour(carData.rate_per_hour?.toString() || "0");
          setDisplayRatePerDistance(carData.rate_per_unit_distance?.toString() || "0");
          setDisplayConvenienceFees(carData.convenience_fees?.toString() || "0");
          setDisplayFleetAdminFee(carData.fleet_admin_fee?.toString() || "0");
        }
      }
    } else {
      setData({
        name: "",
        base_fare: 0,
        convenience_fee_type: "",
        pos: "",
        convenience_fees: 0,
        rate_per_hour: 0,
        extra_info: "",
        min_fare: 0,
        rate_per_unit_distance: 0,
        fleet_admin_fee: 0,
        image: "https://cdn.pixabay.com/photo/2012/04/15/22/09/car-35502__480.png",
        category: settings?.appCat || "test",
      })

      // Initialize display values for new car type
      setDisplayBaseFare("0");
      setDisplayMinFare("0");
      setDisplayRatePerHour("0");
      setDisplayRatePerDistance("0");
      setDisplayConvenienceFees("0");
      setDisplayFleetAdminFee("0");
    }
  }, [cartypes, cartypes.cars, id, navigate, settings?.country,settings?.appCat]);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const handleInputToNumberChange = (e) => {
    let value = e.target.value;
    if (value.length > 1) {
      value = value.replace(/^0+/, "");
    }
    setData({ ...data, [e.target.id]: value === "" ? "" : value });
  };

  // Vietnamese number input handlers
  const handleBaseFareChange = (e) => {
    const isVietnamese = settings?.country === "Vietnam";
    handleVietnameseNumberInput(
      e.target.value, 
      isVietnamese, 
      (numericValue) => setData({ ...data, base_fare: numericValue }),
      setDisplayBaseFare
    );
  };

  const handleMinFareChange = (e) => {
    const isVietnamese = settings?.country === "Vietnam";
    handleVietnameseNumberInput(
      e.target.value, 
      isVietnamese, 
      (numericValue) => setData({ ...data, min_fare: numericValue }),
      setDisplayMinFare
    );
  };

  const handleRatePerHourChange = (e) => {
    const isVietnamese = settings?.country === "Vietnam";
    handleVietnameseNumberInput(
      e.target.value, 
      isVietnamese, 
      (numericValue) => setData({ ...data, rate_per_hour: numericValue }),
      setDisplayRatePerHour
    );
  };

  const handleRatePerDistanceChange = (e) => {
    const isVietnamese = settings?.country === "Vietnam";
    handleVietnameseNumberInput(
      e.target.value, 
      isVietnamese, 
      (numericValue) => setData({ ...data, rate_per_unit_distance: numericValue }),
      setDisplayRatePerDistance
    );
  };

  const handleConvenienceFeesChange = (e) => {
    const isVietnamese = settings?.country === "Vietnam";
    handleVietnameseNumberInput(
      e.target.value, 
      isVietnamese, 
      (numericValue) => setData({ ...data, convenience_fees: numericValue }),
      setDisplayConvenienceFees
    );
  };

  const handleFleetAdminFeeChange = (e) => {
    const isVietnamese = settings?.country === "Vietnam";
    handleVietnameseNumberInput(
      e.target.value, 
      isVietnamese, 
      (numericValue) => setData({ ...data, fleet_admin_fee: numericValue }),
      setDisplayFleetAdminFee
    );
  };

  const handleExtraInfoChange = (e) => {
    setData({ ...data, extra_info: e.target.value });
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  // Convert numeric string fields to actual numbers
  const convertDataToNumbers = (dataObj) => {
    return {
      ...dataObj,
      base_fare: parseFloat(dataObj.base_fare) || 0,
      min_fare: parseFloat(dataObj.min_fare) || 0,
      rate_per_hour: parseFloat(dataObj.rate_per_hour) || 0,
      rate_per_unit_distance: parseFloat(dataObj.rate_per_unit_distance) || 0,
      convenience_fees: parseFloat(dataObj.convenience_fees) || 0,
      fleet_admin_fee: parseFloat(dataObj.fleet_admin_fee) || 0,
      pos: parseInt(dataObj.pos) || 0,
    };
  };

  //time interval options for cron expression
  const timeStrToMin = (hhmm) => {
    if (!hhmm || typeof hhmm !== "string") return 0;
    const [h, m] = hhmm.split(":").map((x) => parseInt(x, 10));
    if (Number.isNaN(h) || Number.isNaN(m)) return 0;
    return Math.max(0, Math.min(1439, h * 60 + m));
  };

  const minToTimeStr = (min) => {
    const m = Math.max(0, Math.min(1439, parseInt(min ?? 0, 10)));
    const hh = String(Math.floor(m / 60)).padStart(2, "0");
    const mm = String(m % 60).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  // Normalize existing time_pricing rules from object -> array for editing
  const normalizeTimePricing = (tp) => {
    if (!tp) return { enabled: false, configured_timezone_id: null, rulesArr: [] };
    const enabled = Boolean(tp.enabled);
    const configured_timezone_id = tp.configured_timezone_id || null;

    // accept object format: rules: { r1: {...}, r2: {...} }
    if (tp.rules && !Array.isArray(tp.rules) && typeof tp.rules === "object") {
      const rulesArr = Object.keys(tp.rules)
        .map((rid) => ({ rid, ...tp.rules[rid] }))
        .sort((a, b) => (a.start_min ?? 0) - (b.start_min ?? 0));
      return { enabled, configured_timezone_id, rulesArr };
    }

    // accept array format if you ever store it
    const rulesArr = Array.isArray(tp.rules) ? tp.rules : [];
    return { enabled, configured_timezone_id, rulesArr };
  };

  // Convert array -> object for saving
  const rulesArrayToObject = (rulesArr) => {
    const out = {};
    (rulesArr || []).forEach((r, idx) => {
      const rid = r.rid || `r${idx + 1}`;
      out[rid] = {
        start_min: Number(r.start_min) || 0,
        end_min: Number(r.end_min) || 0,
        base_fare: Number(r.base_fare) || 0,
      };
    });
    return out;
  };

  // Minimal validation: no duplicates / overlaps
  const validateRules = (rulesArr) => {
    if (!rulesArr || rulesArr.length === 0) return t("time_pricing_rules_required");

    const normalized = rulesArr.map((r) => ({
      ...r,
      start_min: Number(r.start_min),
      end_min: Number(r.end_min),
    }));

    // validações básicas
    for (const r of normalized) {
      if (!Number.isFinite(r.start_min) || !Number.isFinite(r.end_min)) {
        return t("time_pricing_invalid_time");
      }
      if (r.start_min < 0 || r.end_min > 1439) return t("time_pricing_out_of_range");
      if (r.start_min >= r.end_min) return t("time_pricing_start_before_end");
    }

    // ordena por start
    const sorted = [...normalized].sort((a, b) => a.start_min - b.start_min);

    // sem sobreposição / duplicado
    for (let i = 1; i < sorted.length; i++) {
      const prev = sorted[i - 1];
      const cur = sorted[i];
      if (cur.start_min <= prev.end_min) return t("time_pricing_duplicate_or_overlap");
    }

    // ✅ exige cobertura 24h sem buracos
    if (sorted[0].start_min !== 0) return t("time_pricing_must_start_midnight");
    if (sorted[sorted.length - 1].end_min !== 1439) return t("time_pricing_must_end_2359");

    for (let i = 1; i < sorted.length; i++) {
      const prev = sorted[i - 1];
      const cur = sorted[i];
      if (cur.start_min !== prev.end_min + 1) return t("time_pricing_no_gaps");
    }

    return null;
  };

  const getMinutesOfDayInTZ = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(date);

    const hh = parseInt(parts.find((p) => p.type === "hour")?.value ?? "0", 10);
    const mm = parseInt(parts.find((p) => p.type === "minute")?.value ?? "0", 10);
    return hh * 60 + mm;
  };

  const getActiveRuleBaseFare = (rulesArr, timeZone) => {
    const nowMin = getMinutesOfDayInTZ(new Date(), timeZone);
    const match = (rulesArr || []).find(
      (r) => nowMin >= Number(r.start_min) && nowMin <= Number(r.end_min)
    );
    return match ? Number(match.base_fare) || 0 : null;
  };

  const buildPayloadWithTimePricing = (src) => {
    const payload = { ...src };

    if (payload?.use_time_pricing) {
      if (!timezoneEnabled) {
        setCommonAlert({ open: true, msg: t("timezone_required_to_enable_time_pricing") });
        return null;
      }

      const rulesArr = payload?.time_pricing?.rulesArr || [];
      const err = validateRules(rulesArr);
      if (err) {
        setCommonAlert({ open: true, msg: err });
        return null;
      }

      payload.time_pricing = {
        enabled: true,
        configured_timezone_id: serviceTimezoneId,
        rules: rulesArrayToObject(rulesArr),
      };
    } else {
      // se não usa intervalos, desliga time_pricing
      if (payload.time_pricing) payload.time_pricing = { enabled: false };
    }

    return payload;
  };

  useEffect(() => {
    if (!data?.use_time_pricing || !timezoneEnabled) return;

    const rulesArr = data?.time_pricing?.rulesArr || [];
    const err = validateRules(rulesArr);
    if (err) return;

    const apply = () => {
      const active = getActiveRuleBaseFare(rulesArr, serviceTimezoneId);
      if (active === null) return;

      setData((prev) => {
        if (Number(prev?.base_fare) === Number(active)) return prev;

        // Se quiser manter o display do Vietnam em sincronia:
        if (settings?.country === "Vietnam") {
          setDisplayBaseFare(formatNumberInput(active || 0, "vi-VN"));
        }

        return { ...prev, base_fare: active };
      });
    };

    apply();
    const timer = setInterval(apply, 30000);
    return () => clearInterval(timer);
  }, [data?.use_time_pricing, data?.time_pricing?.rulesArr, timezoneEnabled, serviceTimezoneId]);



  const handleSubmit = () => {
    // -------- ADD --------
    if (!id) {
      const missingRequired =
        !(
          data &&
          data.name &&
          data.pos &&
          data.convenience_fee_type &&
          data.base_fare &&
          data.min_fare &&
          data.rate_per_hour &&
          data.rate_per_unit_distance
        );

      if (missingRequired) {
        if (!(data && data.name)) {
          setCommonAlert({ open: true, msg: t("proper_input_name") });
        } else if (!data.pos) {
          setCommonAlert({ open: true, msg: t("position_required") });
        } else if (!data.base_fare) {
          setCommonAlert({ open: true, msg: t("base_fare_required") });
        } else if (!data.min_fare) {
          setCommonAlert({ open: true, msg: t("min_fare_required") });
        } else if (!data.rate_per_hour) {
          setCommonAlert({ open: true, msg: t("rate_per_hour_required") });
        } else if (!data.rate_per_unit_distance) {
          setCommonAlert({ open: true, msg: t("rate_per_unit_distance_required") });
        } else if (!data.convenience_fee_type) {
          setCommonAlert({ open: true, msg: t("convenience_fee_type_required") });
        }
        return;
      }

      // Somente se estiver válido, tenta salvar
      settings.AllowCriticalEditsAdmin
        ? new Promise((resolve, reject) => {
            setLoding(true);

            setTimeout(async () => {
              try {
                if (!(data && data.name)) {
                  setCommonAlert({ open: true, msg: t("proper_input_name") });
                  reject(new Error("Enter proper name"));
                  return;
                }

                const payload = buildPayloadWithTimePricing(data);
                if (!payload) {
                  // buildPayloadWithTimePricing já deve ter mostrado o alert
                  reject(new Error("Invalid time pricing"));
                  return;
                }

                const convertedData = convertDataToNumbers(payload);
                convertedData["createdAt"] = new Date().getTime();

                await convertLanguage(
                  convertedData.name,
                  auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null
                );

                dispatch(editCarType(convertedData, "Add"));
                resolve();

                navigate("/cartypes");
              } catch (e) {
                reject(e);
              } finally {
                setLoding(false);
              }
            }, 600);
          })
        : new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              setCommonAlert({ open: true, msg: t("demo_mode") });
            }, 600);
          });

      return;
    }

    // -------- UPDATE --------
    if (id) {
      const missingRequired =
        !(
          data &&
          data.name &&
          data.pos &&
          data.convenience_fee_type &&
          data.base_fare &&
          data.min_fare &&
          data.rate_per_hour &&
          data.rate_per_unit_distance
        );

      if (missingRequired) {
        if (!(data && data.name)) {
          setCommonAlert({ open: true, msg: t("proper_input_name") });
        } else if (!data.pos) {
          setCommonAlert({ open: true, msg: t("position_required") });
        } else if (!data.base_fare) {
          setCommonAlert({ open: true, msg: t("base_fare_required") });
        } else if (!data.min_fare) {
          setCommonAlert({ open: true, msg: t("min_fare_required") });
        } else if (!data.rate_per_hour) {
          setCommonAlert({ open: true, msg: t("rate_per_hour_required") });
        } else if (!data.rate_per_unit_distance) {
          setCommonAlert({ open: true, msg: t("rate_per_unit_distance_required") });
        } else if (!data.convenience_fee_type) {
          setCommonAlert({ open: true, msg: t("convenience_fee_type_required") });
        }
        return;
      }

      settings.AllowCriticalEditsAdmin
        ? new Promise((resolve, reject) => {
            setLoding(true);

            setTimeout(async () => {
              try {
                if (data === oldData) {
                  setCommonAlert({ open: true, msg: t("make_changes_to_update") });
                  resolve();
                  return;
                }

                const payload = buildPayloadWithTimePricing(data);
                if (!payload) {
                  // buildPayloadWithTimePricing já deve ter mostrado o alert
                  reject(new Error("Invalid time pricing"));
                  return;
                }

                const convertedData = convertDataToNumbers(payload);
                delete convertedData.tableData;

                if (convertedData.name !== oldData.name && staticusers) {
                  const users =
                    staticusers &&
                    staticusers.filter(
                      (user) => user.usertype === "driver" && user.carType === oldData.name
                    );

                  for (let i = 0; i < (users?.length || 0); i++) {
                    dispatch(updateUserCar(users[i].id, { carType: convertedData.name }));
                  }

                  const cars = carlistdata.cars.filter((car) => car.carType === oldData.name);
                  for (let i = 0; i < cars.length; i++) {
                    dispatch(editCar({ ...cars[i], carType: convertedData.name }, "Update"));
                  }
                }

                await convertLanguage(
                  convertedData.name,
                  auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null
                );

                dispatch(editCarType(convertedData, "Update"));
                resolve();

                navigate("/cartypes", { state: { pageNo: state?.pageNo } });
              } catch (e) {
                reject(e);
              } finally {
                setLoding(false);
              }
            }, 600);
          })
        : new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              alert(t("demo_mode"));
            }, 600);
          });
    }
  };

  const handleChangeConvenienceFeeType = (e) => {
    setData({ ...data, convenience_fee_type: e.target.value });
  };
  return loding ? (
    <CircularLoading />
  ) : (
    <div>
      <Card
        style={{
          borderRadius: "19px",
          backgroundColor: colors.WHITE,
          minHeight: 100,
          maxWidth: "75vw",
          marginTop: 20,
          marginBottom: 20,
          padding: 25,
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        }}
      >
        <Typography
          variant="h5"
          style={{
            margin: "10px 10px 0 5px",
            textAlign: isRTL === "rtl" ? "right" : "left",
            fontFamily: FONT_FAMILY,
          }}
        >
          {id ? t("update_carType_title") : t("add_carType_title")}
        </Typography>
        <GoBackButton isRTL={isRTL} onClick={() => { navigate("/cartypes", { state: { pageNo: state?.pageNo } }) }} />
        <Grid
          container
          spacing={2}
          sx={{ gridTemplateColumns: "50%", direction: isRTL === "rtl" ? "rtl" : "ltr", }}
        >
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("name")}
              id="name"
              value={data?.name || ""}
              fullWidth
              onChange={handleInputChange}
              className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("base_fare")}
              id="base_fare"
              value={settings?.country === "Vietnam" ? displayBaseFare : (data?.base_fare || 0)}
              fullWidth
              type={settings?.country === "Vietnam" ? "text" : "number"}
              onChange={settings?.country === "Vietnam" ? handleBaseFareChange : handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_3 : classes.textField
              }
              disabled={Boolean(data?.use_time_pricing)}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography
              component="h1"
              variant="h6"
              style={{ marginTop: "15px", textAlign: isRTL === "rtl" ? "right" : "left", fontFamily: FONT_FAMILY }}
            >
              {t("time_pricing_title")}
            </Typography>

            <Typography style={{ opacity: 0.85, fontFamily: FONT_FAMILY, marginTop: 6 }}>
              {t("configured_timezone")}: <b>{serviceTimezoneId}</b>
            </Typography>

            {!timezoneEnabled ? (
              <Typography style={{ marginTop: 8, color: "#b00020", fontFamily: FONT_FAMILY }}>
                {t("timezone_required_to_enable_time_pricing")}
              </Typography>
            ) : null}

            <FormControlLabel
              style={{ marginTop: 8, flexDirection: isRTL === "rtl" ? "row-reverse" : "row" }}
              control={
                <Switch
                  checked={Boolean(data?.use_time_pricing)}
                  onChange={(e) => {
                    const enabled = e.target.checked;
                    const tp = normalizeTimePricing(data?.time_pricing);
                    setData({
                      ...data,
                      use_time_pricing: enabled,
                      time_pricing: {
                        enabled,
                        configured_timezone_id: enabled ? serviceTimezoneId : (tp.configured_timezone_id || null),
                        rulesArr: tp.rulesArr || []
                      }
                    });
                  }}
                  name="use_time_pricing"
                  color="primary"
                  disabled={!timezoneEnabled}
                />
              }
              label={<Typography className={classes.typography}>{t("use_time_pricing_switch")}</Typography>}
            />

            {Boolean(data?.use_time_pricing) ? (
              <Grid container spacing={2} style={{ marginTop: 6 }}>
                <Grid item xs={12}>
                  <Typography style={{ opacity: 0.85, fontFamily: FONT_FAMILY }}>
                    {t("time_pricing_hint")}
                  </Typography>
                </Grid>

                {(data?.time_pricing?.rulesArr || []).map((r, idx) => (
                  <React.Fragment key={r.rid || idx}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        label={t("start_time")}
                        type="time"
                        fullWidth
                        value={minToTimeStr(r.start_min)}
                        onChange={(e) => {
                          const start_min = timeStrToMin(e.target.value);
                          const rulesArr = [...(data.time_pricing.rulesArr || [])];
                          rulesArr[idx] = { ...rulesArr[idx], start_min };
                          setData({ ...data, time_pricing: { ...data.time_pricing, rulesArr } });
                        }}
                        className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        label={t("end_time")}
                        type="time"
                        fullWidth
                        value={minToTimeStr(r.end_min)}
                        onChange={(e) => {
                          const end_min = timeStrToMin(e.target.value);
                          const rulesArr = [...(data.time_pricing.rulesArr || [])];
                          rulesArr[idx] = { ...rulesArr[idx], end_min };
                          setData({ ...data, time_pricing: { ...data.time_pricing, rulesArr } });
                        }}
                        className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        label={t("base_fare_for_interval")}
                        id={`interval_base_fare_${idx}`}
                        type="number"
                        fullWidth
                        value={r.base_fare ?? 0}
                        onChange={(e) => {
                          const base_fare = e.target.value;
                          const rulesArr = [...(data.time_pricing.rulesArr || [])];
                          rulesArr[idx] = { ...rulesArr[idx], base_fare };
                          setData({ ...data, time_pricing: { ...data.time_pricing, rulesArr } });
                        }}
                        className={isRTL === "rtl" ? classes.rootRtl_3 : classes.textField}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          const rulesArr = [...(data.time_pricing.rulesArr || [])];
                          rulesArr.splice(idx, 1);
                          setData({ ...data, time_pricing: { ...data.time_pricing, rulesArr } });
                        }}
                        style={{ fontFamily: FONT_FAMILY }}
                      >
                        {t("remove_interval")}
                      </Button>
                    </Grid>
                  </React.Fragment>
                ))}

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      const rulesArr = [...(data?.time_pricing?.rulesArr || [])];

                      // acha o final do último intervalo (maior end_min)
                      let start_min = 0;
                      if (rulesArr.length > 0) {
                        const last = [...rulesArr]
                          .sort((a, b) => Number(a.end_min) - Number(b.end_min))
                          .pop();
                        start_min = Math.min(1439, Number(last?.end_min ?? 0) + 1);
                      }

                      // se já chegou no fim do dia, não adiciona
                      if (start_min > 1439) {
                        setCommonAlert({ open: true, msg: t("time_pricing_day_already_covered") });
                        return;
                      }

                      const end_min = Math.min(1439, start_min + 60);

                      rulesArr.push({
                        rid: `r${rulesArr.length + 1}`,
                        start_min,
                        end_min,
                        base_fare: Number(data?.base_fare) || 0,
                      });

                      setData({
                        ...data,
                        time_pricing: {
                          ...data.time_pricing,
                          enabled: true,
                          configured_timezone_id: serviceTimezoneId,
                          rulesArr,
                        },
                      });
                    }}
                    style={{ fontFamily: FONT_FAMILY }}
                  >
                    {t("add_interval")}
                  </Button>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
          
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl
              fullWidth
              style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
            >
              <InputLabel
                id="demo-simple-select-label"
                className={isRTL === "rtl" ? classes.right : ""}
                sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}
              >
                {<Typography className={classes.typography}>{t("convenience_fee_type")}</Typography>}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="convenience_fee_type"
                value={data?.convenience_fee_type || ""}
                label={t("convenience_fee_type")}
                onChange={handleChangeConvenienceFeeType}
                className={
                  isRTL === "rtl"
                    ? classes.selectField_rtl
                    : classes.selectField
                }
              >
                <MenuItem
                  style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                  value={"flat"}
                >
                  {<Typography className={classes.typography}>{t("flat")}</Typography>}
                </MenuItem>
                <MenuItem
                  style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                  value={"percentage"}
                >
                  {<Typography className={classes.typography}>{t("percentage")}</Typography>}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("convenience_fee")}
              id="convenience_fees"
              value={settings?.country === "Vietnam" ? displayConvenienceFees : (data?.convenience_fees || 0)}
              type={settings?.country === "Vietnam" ? "text" : "number"}
              fullWidth
              onChange={settings?.country === "Vietnam" ? handleConvenienceFeesChange : handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_4 : classes.textField
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("rate_per_hour")}
              id="rate_per_hour"
              value={settings?.country === "Vietnam" ? displayRatePerHour : (data?.rate_per_hour || 0)}
              type={settings?.country === "Vietnam" ? "text" : "number"}
              fullWidth
              onChange={settings?.country === "Vietnam" ? handleRatePerHourChange : handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_3 : classes.textField
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("min_fare")}
              id="min_fare"
              value={settings?.country === "Vietnam" ? displayMinFare : (data?.min_fare || 0)}
              type={settings?.country === "Vietnam" ? "text" : "number"}
              fullWidth
              onChange={settings?.country === "Vietnam" ? handleMinFareChange : handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_2 : classes.textField
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("rate_per_unit_distance")}
              id="rate_per_unit_distance"
              value={settings?.country === "Vietnam" ? displayRatePerDistance : (data?.rate_per_unit_distance || 0)}
              type={settings?.country === "Vietnam" ? "text" : "number"}
              fullWidth
              onChange={settings?.country === "Vietnam" ? handleRatePerDistanceChange : handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_1 : classes.textField
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("position")}
              id="pos"
              value={data?.pos || 0}
              type="number"
              fullWidth
              onChange={handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_4 : classes.textField
              }
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("fleet_admin_fee")}
              id="fleet_admin_fee"
              value={settings?.country === "Vietnam" ? displayFleetAdminFee : (data?.fleet_admin_fee || 0)}
              type={settings?.country === "Vietnam" ? "text" : "number"}
              fullWidth
              onChange={settings?.country === "Vietnam" ? handleFleetAdminFeeChange : handleInputToNumberChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_5 : classes.textField
              }
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              label={t("extra_info")}
              id="extra_info"
              value={data?.extra_info || ""}
              fullWidth
              onChange={handleExtraInfoChange}
              className={
                isRTL === "rtl" ? classes.rootRtl_3 : classes.textField
              }
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button
              style={{
                borderRadius: "19px",
                backgroundColor: MAIN_COLOR,
                minHeight: 50,
                minWidth: "50%",
                textAlign: "center",
                boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
              }}
              onClick={handleSubmit}
              variant="contained"
            >
              <Typography
                style={{
                  color: colors.WHITE,
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  fontFamily: FONT_FAMILY,
                }}
              >
                {id ? t("update") : t("submit")}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Card>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
};

export default EditCarType
